<div class="overlay" (click)="cerrar.emit()">
  <div class="modal" (click)="$event.stopPropagation()">
    <h2>{{ titulo }}</h2>
    <p class="mensaje">{{ mensaje }}</p>
    <p class="instruccion">Para confirmar, escribe el siguiente código en el campo de abajo:</p>
    <div class="fila-codigo">
      <strong class="codigo">{{ codigoConfirmacion }}</strong>
      <button type="button" class="boton-copiar" (click)="copiarCodigo()">{{ copiado() ? '✓ Copiado' : '📋 Copiar' }}</button>
    </div>
    <input
      class="campo-confirmacion"
      [ngModel]="texto()"
      (ngModelChange)="texto.set($event)"
      [placeholder]="codigoConfirmacion"
      [disabled]="eliminando()"
      autocomplete="off"
    />

    @if (error(); as msg) {
      <p class="mensaje-error">{{ msg }}</p>
    }

    <div class="pie">
      <button type="button" (click)="cerrar.emit()" [disabled]="eliminando()">Cancelar</button>
      <button type="button" class="boton-peligro" [disabled]="!coincide || eliminando()" (click)="confirmar()">
        {{ eliminando() ? 'Eliminando…' : 'Eliminar definitivamente' }}
      </button>
    </div>
  </div>
</div>
